







































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  NotificationType,
  Notification,
  Advice3
} from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Button
  }
})
export default class Notifier extends Vue {
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  userAdvisorStore = useUserAdvisorStore();

  @Prop({ required: false, default: false })
  isPartnerHomeHeaderVisible: boolean;

  displayAdvisor3Popup = true;
  advisor3Timeout = null;

  get advice3 (): Advice3 {
    // clear timeout and set the flag to true when we load a new message
    clearTimeout(this.advisor3Timeout);
    this.displayAdvisor3Popup = true;

    if (this.userAdvisorStore.bannerAdvice3 !== undefined && this.userAdvisorStore.bannerAdvice3 !== null) {
      // setting timeout for advisor3 message to 15 seconds
      this.advisor3Timeout = window.setTimeout(() => {
        this.displayAdvisor3Popup = false;
      }, 15000);
      return this.userAdvisorStore.bannerAdvice3;
    } else {
      return null;
    }
  }

  get linkTarget () {
    return this.advice3.isLinkTargetNew ? "_blank" : "_self";
  }

  get isRouteLink () {
    return this.advice3.link && this.advice3.isRouteLink;
  }

  trimExcessCharacters (message: string) {
    const characterLimit = 160;
    if (message.length > characterLimit) {
      let trimmedMessage = message.substr(0, characterLimit);
      trimmedMessage = trimmedMessage.substr(0, Math.min(trimmedMessage.length, trimmedMessage.lastIndexOf(" ")));
      return `${trimmedMessage} ...`;
    }
    return message;
  }

  linkText (advice3: Advice3) {
    if (advice3.linkText !== null && advice3.linkText.length > 0) {
      return advice3.linkText;
    }
    return advice3.link;
  }

  alertType (notification: Notification) {
    let type = "notification alert alert-";

    switch (notification.type) {
      case NotificationType.Danger:
        type += "danger";
        return type;
      case NotificationType.Info:
        type += "info";
        return type;
      case NotificationType.Success:
        type += "success";
        return type;
      case NotificationType.Warning:
        type += "warning";
        return type;
      default:
        type += "primary";
        return type;
    }
  }

  closeAlert (index: number) {
    this.notifierStore.clear(index);
  }

}
